(ns hai.home.desktop.newtab-toggle
  "The \"Open Humble on new tabs\" control shown under the clock on Home.

   Home is what the browser extension frames as the new-tab page, so this is
   the surface where the override is most discoverable — the setting is
   otherwise buried in the profile page. It reads and writes exactly the same
   state as that settings row (`:user-config.newtab/override?`, via
   `auth/set-newtab-override`), so flipping either updates both — same plain
   `c/Switch` the profile row uses."
  (:require
   [hai.ui.components :as c]
   [hai.ui.rf-sugar :refer [<s >e]]
   [hai.ui.tokens :as t]
   [hai.web-app.auth :as auth]
   [lambdaisland.ornament :as o]))

(def ^:private label-id "home-newtab-toggle-label")

;; Left-aligned in the whitespace under the clock card rather than absolutely
;; positioned: it fills the space below the time/date that only looks empty on
;; wide viewports, and stays anchored to the clock as the layout reflows.
(o/defstyled toolbar :div
  {:display         "flex"
   :justify-content "flex-start"
   :align-items     "center"
   :margin-top      "16px"})

(o/defstyled pill :div
  {:display       "inline-flex"
   :align-items   "center"
   :gap           "10px"
   :padding       "7px 14px"
   :border-radius "999px"
   :background    t/--colour-chalk}
  [:.label
   {:font-size   "13px"
    :font-weight "500"
    :line-height "1.2"
    :color       t/--colour-dim
    :user-select "none"}])

(defn control
  "Toggle for the new-tab override, shown under the clock on the Home page."
  []
  (let [on? (boolean (:user-config.newtab/override? @(<s :auth/identity)))]
    [toolbar
     [pill
      [:span.label {:id label-id} auth/newtab-toggle-label]
      ;; Named by the visible label rather than a separate `aria-label`, so the
      ;; accessible name and the on-screen text can't diverge.
      [c/Switch
       {:checked           on?
        :aria-labelledby   label-id
        :on-checked-change #(>e [::auth/set-newtab-override %])}]]]))
